import { render, staticRenderFns } from "./ArrivalRegister.vue?vue&type=template&id=74131484&scoped=true"
import script from "./ArrivalRegister.vue?vue&type=script&lang=js"
export * from "./ArrivalRegister.vue?vue&type=script&lang=js"
import style0 from "./ArrivalRegister.vue?vue&type=style&index=0&id=74131484&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74131484",
  null
  
)

export default component.exports